import ApiBase from '../ApiBase';

export default new class extends ApiBase {
    route = 'admin/surveys/:survey/imports';
}
